/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as InvitationsTokenRouteImport } from './routes/invitations.$token'
import { Route as PatientsIndexRouteImport } from './routes/patients/index'
import { Route as SessionsIndexRouteImport } from './routes/sessions/index'
import { Route as SessionsSessionIdRouteImport } from './routes/sessions/$sessionId'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as SettingsAccountRouteImport } from './routes/settings/account'
import { Route as SettingsGeneralRouteImport } from './routes/settings/general'
import { Route as SettingsOrganizationRouteImport } from './routes/settings/organization'
import { Route as UploadIndexRouteImport } from './routes/upload/index'
import { Route as PatientsPatientIdIndexRouteImport } from './routes/patients/$patientId/index'
import { Route as SettingsNotesIndexRouteImport } from './routes/settings/notes/index'
import { Route as PatientsPatientIdSessionsSessionIdRouteImport } from './routes/patients/$patientId/sessions/$sessionId'
import { Route as SettingsNotesManageIndexRouteImport } from './routes/settings/notes/manage/index'
import { Route as SettingsNotesManageNoteTypeIdRouteImport } from './routes/settings/notes/manage/$noteTypeId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationsTokenRoute = InvitationsTokenRouteImport.update({
  id: '/invitations/$token',
  path: '/invitations/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientsIndexRoute = PatientsIndexRouteImport.update({
  id: '/patients/',
  path: '/patients/',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionsIndexRoute = SessionsIndexRouteImport.update({
  id: '/sessions/',
  path: '/sessions/',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionsSessionIdRoute = SessionsSessionIdRouteImport.update({
  id: '/sessions/$sessionId',
  path: '/sessions/$sessionId',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsAccountRoute = SettingsAccountRouteImport.update({
  id: '/settings/account',
  path: '/settings/account',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsGeneralRoute = SettingsGeneralRouteImport.update({
  id: '/settings/general',
  path: '/settings/general',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsOrganizationRoute = SettingsOrganizationRouteImport.update({
  id: '/settings/organization',
  path: '/settings/organization',
  getParentRoute: () => rootRouteImport,
} as any)
const UploadIndexRoute = UploadIndexRouteImport.update({
  id: '/upload/',
  path: '/upload/',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientsPatientIdIndexRoute = PatientsPatientIdIndexRouteImport.update({
  id: '/patients/$patientId/',
  path: '/patients/$patientId/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsNotesIndexRoute = SettingsNotesIndexRouteImport.update({
  id: '/settings/notes/',
  path: '/settings/notes/',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientsPatientIdSessionsSessionIdRoute =
  PatientsPatientIdSessionsSessionIdRouteImport.update({
    id: '/patients/$patientId/sessions/$sessionId',
    path: '/patients/$patientId/sessions/$sessionId',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsNotesManageIndexRoute =
  SettingsNotesManageIndexRouteImport.update({
    id: '/settings/notes/manage/',
    path: '/settings/notes/manage/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsNotesManageNoteTypeIdRoute =
  SettingsNotesManageNoteTypeIdRouteImport.update({
    id: '/settings/notes/manage/$noteTypeId',
    path: '/settings/notes/manage/$noteTypeId',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/invitations/$token': typeof InvitationsTokenRoute
  '/sessions/$sessionId': typeof SessionsSessionIdRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/organization': typeof SettingsOrganizationRoute
  '/patients/': typeof PatientsIndexRoute
  '/sessions/': typeof SessionsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/upload/': typeof UploadIndexRoute
  '/patients/$patientId/': typeof PatientsPatientIdIndexRoute
  '/settings/notes/': typeof SettingsNotesIndexRoute
  '/patients/$patientId/sessions/$sessionId': typeof PatientsPatientIdSessionsSessionIdRoute
  '/settings/notes/manage/$noteTypeId': typeof SettingsNotesManageNoteTypeIdRoute
  '/settings/notes/manage/': typeof SettingsNotesManageIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/invitations/$token': typeof InvitationsTokenRoute
  '/sessions/$sessionId': typeof SessionsSessionIdRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/organization': typeof SettingsOrganizationRoute
  '/patients': typeof PatientsIndexRoute
  '/sessions': typeof SessionsIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/upload': typeof UploadIndexRoute
  '/patients/$patientId': typeof PatientsPatientIdIndexRoute
  '/settings/notes': typeof SettingsNotesIndexRoute
  '/patients/$patientId/sessions/$sessionId': typeof PatientsPatientIdSessionsSessionIdRoute
  '/settings/notes/manage/$noteTypeId': typeof SettingsNotesManageNoteTypeIdRoute
  '/settings/notes/manage': typeof SettingsNotesManageIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/invitations/$token': typeof InvitationsTokenRoute
  '/sessions/$sessionId': typeof SessionsSessionIdRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/organization': typeof SettingsOrganizationRoute
  '/patients/': typeof PatientsIndexRoute
  '/sessions/': typeof SessionsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/upload/': typeof UploadIndexRoute
  '/patients/$patientId/': typeof PatientsPatientIdIndexRoute
  '/settings/notes/': typeof SettingsNotesIndexRoute
  '/patients/$patientId/sessions/$sessionId': typeof PatientsPatientIdSessionsSessionIdRoute
  '/settings/notes/manage/$noteTypeId': typeof SettingsNotesManageNoteTypeIdRoute
  '/settings/notes/manage/': typeof SettingsNotesManageIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/onboarding'
    | '/reset-password'
    | '/signup'
    | '/invitations/$token'
    | '/sessions/$sessionId'
    | '/settings/account'
    | '/settings/general'
    | '/settings/organization'
    | '/patients/'
    | '/sessions/'
    | '/settings/'
    | '/upload/'
    | '/patients/$patientId/'
    | '/settings/notes/'
    | '/patients/$patientId/sessions/$sessionId'
    | '/settings/notes/manage/$noteTypeId'
    | '/settings/notes/manage/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/onboarding'
    | '/reset-password'
    | '/signup'
    | '/invitations/$token'
    | '/sessions/$sessionId'
    | '/settings/account'
    | '/settings/general'
    | '/settings/organization'
    | '/patients'
    | '/sessions'
    | '/settings'
    | '/upload'
    | '/patients/$patientId'
    | '/settings/notes'
    | '/patients/$patientId/sessions/$sessionId'
    | '/settings/notes/manage/$noteTypeId'
    | '/settings/notes/manage'
  id:
    | '__root__'
    | '/'
    | '/forgot-password'
    | '/onboarding'
    | '/reset-password'
    | '/signup'
    | '/invitations/$token'
    | '/sessions/$sessionId'
    | '/settings/account'
    | '/settings/general'
    | '/settings/organization'
    | '/patients/'
    | '/sessions/'
    | '/settings/'
    | '/upload/'
    | '/patients/$patientId/'
    | '/settings/notes/'
    | '/patients/$patientId/sessions/$sessionId'
    | '/settings/notes/manage/$noteTypeId'
    | '/settings/notes/manage/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  OnboardingRoute: typeof OnboardingRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
  InvitationsTokenRoute: typeof InvitationsTokenRoute
  SessionsSessionIdRoute: typeof SessionsSessionIdRoute
  SettingsAccountRoute: typeof SettingsAccountRoute
  SettingsGeneralRoute: typeof SettingsGeneralRoute
  SettingsOrganizationRoute: typeof SettingsOrganizationRoute
  PatientsIndexRoute: typeof PatientsIndexRoute
  SessionsIndexRoute: typeof SessionsIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  UploadIndexRoute: typeof UploadIndexRoute
  PatientsPatientIdIndexRoute: typeof PatientsPatientIdIndexRoute
  SettingsNotesIndexRoute: typeof SettingsNotesIndexRoute
  PatientsPatientIdSessionsSessionIdRoute: typeof PatientsPatientIdSessionsSessionIdRoute
  SettingsNotesManageNoteTypeIdRoute: typeof SettingsNotesManageNoteTypeIdRoute
  SettingsNotesManageIndexRoute: typeof SettingsNotesManageIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitations/$token': {
      id: '/invitations/$token'
      path: '/invitations/$token'
      fullPath: '/invitations/$token'
      preLoaderRoute: typeof InvitationsTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patients/': {
      id: '/patients/'
      path: '/patients'
      fullPath: '/patients/'
      preLoaderRoute: typeof PatientsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sessions/': {
      id: '/sessions/'
      path: '/sessions'
      fullPath: '/sessions/'
      preLoaderRoute: typeof SessionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sessions/$sessionId': {
      id: '/sessions/$sessionId'
      path: '/sessions/$sessionId'
      fullPath: '/sessions/$sessionId'
      preLoaderRoute: typeof SessionsSessionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/account': {
      id: '/settings/account'
      path: '/settings/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof SettingsAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/general': {
      id: '/settings/general'
      path: '/settings/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof SettingsGeneralRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/organization': {
      id: '/settings/organization'
      path: '/settings/organization'
      fullPath: '/settings/organization'
      preLoaderRoute: typeof SettingsOrganizationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/upload/': {
      id: '/upload/'
      path: '/upload'
      fullPath: '/upload/'
      preLoaderRoute: typeof UploadIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patients/$patientId/': {
      id: '/patients/$patientId/'
      path: '/patients/$patientId'
      fullPath: '/patients/$patientId/'
      preLoaderRoute: typeof PatientsPatientIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/notes/': {
      id: '/settings/notes/'
      path: '/settings/notes'
      fullPath: '/settings/notes/'
      preLoaderRoute: typeof SettingsNotesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patients/$patientId/sessions/$sessionId': {
      id: '/patients/$patientId/sessions/$sessionId'
      path: '/patients/$patientId/sessions/$sessionId'
      fullPath: '/patients/$patientId/sessions/$sessionId'
      preLoaderRoute: typeof PatientsPatientIdSessionsSessionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/notes/manage/': {
      id: '/settings/notes/manage/'
      path: '/settings/notes/manage'
      fullPath: '/settings/notes/manage/'
      preLoaderRoute: typeof SettingsNotesManageIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/notes/manage/$noteTypeId': {
      id: '/settings/notes/manage/$noteTypeId'
      path: '/settings/notes/manage/$noteTypeId'
      fullPath: '/settings/notes/manage/$noteTypeId'
      preLoaderRoute: typeof SettingsNotesManageNoteTypeIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  OnboardingRoute: OnboardingRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
  InvitationsTokenRoute: InvitationsTokenRoute,
  SessionsSessionIdRoute: SessionsSessionIdRoute,
  SettingsAccountRoute: SettingsAccountRoute,
  SettingsGeneralRoute: SettingsGeneralRoute,
  SettingsOrganizationRoute: SettingsOrganizationRoute,
  PatientsIndexRoute: PatientsIndexRoute,
  SessionsIndexRoute: SessionsIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  UploadIndexRoute: UploadIndexRoute,
  PatientsPatientIdIndexRoute: PatientsPatientIdIndexRoute,
  SettingsNotesIndexRoute: SettingsNotesIndexRoute,
  PatientsPatientIdSessionsSessionIdRoute:
    PatientsPatientIdSessionsSessionIdRoute,
  SettingsNotesManageNoteTypeIdRoute: SettingsNotesManageNoteTypeIdRoute,
  SettingsNotesManageIndexRoute: SettingsNotesManageIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
